import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8107ffa2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "body"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "float": "right"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "col_bblue"
};
const _hoisted_4 = {
  key: 1,
  class: "col_bblue"
};
const _hoisted_5 = {
  style: {
    "color": "#7e7f86",
    "margin-left": "10px"
  }
};
const _hoisted_6 = {
  style: {
    "color": "#7e7f86",
    "margin-left": "10px"
  }
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "flex-wrap": "wrap"
  }
};
const _hoisted_8 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_9 = {
  style: {
    "width": "130px",
    "height": "130px",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "margin-bottom": "15px"
  }
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  style: {
    "width": "120px",
    "margin-top": "6px",
    "height": "30px",
    "text-align": "center",
    "line-height": "28px",
    "color": "rgb(126,127,134)",
    "overflow": "hidden",
    "text-overflow": "ellipsis",
    "white-space": "nowrap"
  }
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
};
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  key: 0,
  style: {
    "margin-top": "19px"
  }
};
const _hoisted_23 = {
  style: {
    "width": "120px",
    "height": "28px",
    "line-height": "14px",
    "text-align": "center",
    "color": "rgb(126,127,134)"
  }
};

const _hoisted_24 = /*#__PURE__*/_createTextVNode(" (用户未上传) ");

const _hoisted_25 = {
  key: 1,
  style: {
    "margin-top": "16px"
  }
};
const _hoisted_26 = {
  style: {
    "width": "120px",
    "height": "28px",
    "line-height": "28px",
    "text-align": "center",
    "color": "rgb(126,127,134)"
  }
};

const _hoisted_27 = /*#__PURE__*/_createTextVNode(" (用户上传) ");

const _hoisted_28 = {
  style: {
    "width": "90%",
    "margin": "0 auto"
  }
};
const _hoisted_29 = {
  key: 0,
  style: {
    "margin": "20px 0 0 10px",
    "color": "#D9001B",
    "display": "flex",
    "width": "100%"
  }
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "white-space": "nowrap",
    "margin-right": "20px"
  }
}, " 补充备注: ", -1));

const _hoisted_31 = {
  style: {
    "width": "80%",
    "word-wrap": "break-word"
  }
};
const _hoisted_32 = {
  style: {
    "white-space": "nowrap",
    "margin-right": "20px"
  }
};
const _hoisted_33 = {
  style: {
    "width": "80%",
    "word-wrap": "break-word"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");

  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_form = _resolveComponent("el-form");

  const _component_el_upload = _resolveComponent("el-upload");

  const _component_el_icon_CircleCloseFilled = _resolveComponent("el-icon-CircleCloseFilled");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_image_viewer = _resolveComponent("el-image-viewer");

  const _component_el_divider = _resolveComponent("el-divider");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [$props.status && $props.status != '1' && $props.status != '5' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$props.status == '2' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$props.isAdmin ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 审核中 ")) : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($props.statusName), 1))], 64)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass($options.getClassByStatus($data.dataInfo.answerVo.checkStatus))
  }, _toDisplayString($data.dataInfo.answerVo.checkStatusName), 3))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass($data.dataInfo.isEssential ? 'star' : ''),
    style: {
      "font-weight": "bold",
      "margin-bottom": "20px",
      "font-size": "14px",
      "margin-right": "150px"
    }
  }, [$props.isAdmin ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createTextVNode(_toDisplayString($data.dataInfo.sortIndex) + ".上传示例" + _toDisplayString($props.isVideo ? '视频' : '图片') + " ", 1), _createElementVNode("span", _hoisted_5, "请根据示例上传" + _toDisplayString($props.isVideo ? '视频' : '图片'), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createTextVNode(_toDisplayString($data.dataInfo.sortIndex) + "." + _toDisplayString($props.isVideo ? $props.damageRTextL.uploadVideo : $props.damageRTextL.uploadImage) + " ", 1), _createElementVNode("span", _hoisted_6, _toDisplayString($props.isVideo ? $props.damageRTextL.uploadVideoExample : $props.damageRTextL.uploadImageExample), 1)], 64))], 2), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataInfo.itemList, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [$props.isVideo ? (_openBlock(), _createElementBlock("div", _hoisted_10, [item.url ? (_openBlock(), _createElementBlock("video", {
      key: 0,
      src: $options.replacePath(item.url),
      class: "avatar",
      autoplay: "",
      controls: "",
      style: {
        "border-radius": "4px",
        "object-fit": "cover"
      }
    }, null, 8, _hoisted_11)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [item.url ? (_openBlock(), _createBlock(_component_el_image, {
      key: 0,
      class: "avatar",
      src: $options.replacePath(item.url),
      "preview-src-list": $data.imgArrayE,
      "initial-index": index,
      style: {
        "border-radius": "4px"
      },
      fit: "cover"
    }, null, 8, ["src", "preview-src-list", "initial-index"])) : _createCommentVNode("", true)])), _createVNode(_component_el_form, {
      style: {
        "margin-top": "13px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tooltip, {
        class: "item",
        effect: "dark",
        content: item.name,
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_13, _toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["content"])]),
      _: 2
    }, 1024)]), _createElementVNode("div", {
      style: {
        "width": "130px",
        "height": "130px",
        "display": "flex",
        "flex-direction": "column",
        "align-items": "center",
        "margin-bottom": "15px"
      },
      onClick: $event => $options.clickShowImage(index)
    }, [_createVNode(_component_el_upload, {
      class: "avatar-uploader",
      action: "/javaplus/user/file/upload",
      "show-file-list": false,
      "on-success": res => {
        $options.handleAvatarSuccess(res, index);
      },
      "before-upload": $options.beforeAvatarUpload,
      disabled: $props.isView
    }, {
      default: _withCtx(() => [$props.isVideo ? (_openBlock(), _createElementBlock("div", _hoisted_15, [$data.itemListCopy[index].url ? (_openBlock(), _createElementBlock("video", {
        key: 0,
        src: $data.itemListCopy[index].url,
        class: "avatar",
        style: {
          "border-radius": "4px",
          "object-fit": "cover"
        },
        autoplay: "",
        controls: ""
      }, null, 8, _hoisted_16)) : (_openBlock(), _createElementBlock("i", _hoisted_17))])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [$data.itemListCopy[index].url ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: $data.itemListCopy[index].url,
        class: "avatar",
        style: {
          "object-fit": "cover",
          "border-radius": "4px"
        }
      }, null, 8, _hoisted_19)) : (_openBlock(), _createElementBlock("i", _hoisted_20))]))]),
      _: 2
    }, 1032, ["on-success", "before-upload", "disabled"]), $props.isView ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [$props.status ? (_openBlock(), _createElementBlock("div", _hoisted_21, [!$data.itemListCopy[index].url ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [$props.isAdmin ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_hoisted_24], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createTextVNode(_toDisplayString($props.damageRTextL.userHasNotUploaded), 1)], 64))])])) : (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [$props.isAdmin ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_hoisted_27], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createTextVNode(_toDisplayString($props.damageRTextL.uploaded), 1)], 64))])]))])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [$data.itemListCopy[index].url ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 0,
      size: 20,
      class: _normalizeClass($data.itemListCopy[index].url ? 'existImg' : ''),
      style: {
        "cursor": "pointer",
        "position": "relative",
        "left": "40px",
        "bottom": "95px",
        "color": "red"
      },
      onClick: $event => $options.clearImg(index)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon_CircleCloseFilled)]),
      _: 2
    }, 1032, ["class", "onClick"])) : _createCommentVNode("", true)], 64))], 8, _hoisted_14)]);
  }), 256))])]), _createElementVNode("div", _hoisted_28, [$data.dataInfo.answerVo?.checkStatus === '1' && $props.status != '2' ? (_openBlock(), _createElementBlock("div", _hoisted_29, [$props.isAdmin ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_30, _createElementVNode("div", _hoisted_31, _toDisplayString($data.dataInfo.answerVo.checkRemark), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_32, _toDisplayString($props.damageRTextL.additionalRemarks) + ": ", 1), _createElementVNode("div", _hoisted_33, _toDisplayString($data.dataInfo.answerVo.checkRemark), 1)], 64))])) : _createCommentVNode("", true)]), $props.isView ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$data.imgViewerShow && $props.status != "1" && $data.dataInfo.questionType == "32" ? (_openBlock(), _createBlock(_component_el_image_viewer, {
    key: 0,
    onClose: _cache[0] || (_cache[0] = $event => $data.imgViewerShow = false),
    infinite: false,
    "url-list": $data.imgArray,
    "initial-index": $data.imgIndex
  }, null, 8, ["url-list", "initial-index"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _createVNode(_component_el_divider)]);
}